/**
 * View-router shim — Phase 3.2.c.
 *
 * admin.js still owns the actual `switchView(...)` implementation
 * (it touches viewConfigs, controlElements, viewElements — all
 * admin.js-internal state). Views that need to navigate between
 * cluster views (e.g. tickets.list calls `switchView('tickets')`)
 * import `switchToView` from here; admin.js wires the underlying
 * function via `setViewRouter` at boot.
 */

let switchViewImpl = () => {};

export function setViewRouter(fn) {
  if (typeof fn === 'function') switchViewImpl = fn;
}

export function switchToView(view, btn) {
  return switchViewImpl(view, btn);
}
